import React, { useEffect, useState } from 'react';
import styles from '../styles/Transactions.module.scss';
import { Helmet } from 'react-helmet-async';

import AddTransaction from '../components/AddTransaction/AddTransaction';
import TransactionsList from '../components/TransactionsList/TransactionsList';
import TransactionsStats from '../components/AddTransaction/TransactionsStats';

export default function Transactions() {
  const [transactions, setTransactions] = useState([]);
  const [filteredForStats, setFilteredForStats] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        setError('');

        const res = await fetch('/api/transactions');
        if (!res.ok) throw new Error('Не удалось загрузить транзакции');

        const data = await res.json();
        setTransactions(Array.isArray(data) ? data : []);
      } catch (e) {
        setError(e?.message || 'Ошибка');
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  const handleCreated = (created) => {
    setTransactions((prev) => [created, ...prev]);
  };

  const handleDelete = async (id) => {
    setTransactions((prev) => prev.filter((t) => t.id !== id));

    const res = await fetch(`/api/transactions/${id}`, { method: 'DELETE' });
    if (!res.ok) alert('Не удалось удалить транзакцию');
  };

  return (
    <>
      <Helmet>
        <title>ФА | Транзакции</title>
      </Helmet>

      <div className={styles.transactions__container}>
        <div className={styles.transactions__left}>
          <AddTransaction onCreated={handleCreated} />
          <TransactionsStats items={filteredForStats} />
        </div>

        <div className={styles.transactions__right}>
          <TransactionsList
            items={transactions}
            loading={loading}
            error={error}
            onDelete={handleDelete}
            onFilteredChange={setFilteredForStats}
          />
        </div>
      </div>
    </>
  );
}
